import jsx from './jsx';
import { getElementsByClassName, makeApiRequest, skeleton } from './utils';

interface StripeProduct {
  url: string;
  expiry: number;
  price: {
    currency: string;
    unit_amount: number;
  };
}

type StripeCache = Record<string, StripeProduct>;

const getStripeCheckoutUrl = async (
  productId: string,
): Promise<StripeProduct> => {
  const cache = localStorage.getItem('stripeCache');
  const parsedCache: StripeCache = JSON.parse(cache || '{}');

  if (parsedCache[productId]) {
    const cachedProduct = parsedCache[productId];
    if (cachedProduct.expiry) {
      if (cachedProduct.expiry > Date.now()) {
        console.log('Stripe link still good!');
        return cachedProduct;
      } else {
        console.log('Stripe link expired!');
      }
    }
  }

  console.log('Stripe product not in cache!');

  const productInfo = await makeApiRequest<StripeProduct>(
    `/stripe/product/${productId}`,
    'GET',
  );

  localStorage.setItem(
    'stripeCache',
    JSON.stringify({
      ...parsedCache,
      [productId]: {
        url: productInfo.url,
        expiry: productInfo.expiry,
        price: {
          currency: productInfo.price.currency,
          // eslint-disable-next-line camelcase
          unit_amount: productInfo.price.unit_amount,
        },
      },
    } as StripeCache),
  );

  return productInfo;
};

window.addEventListener('DOMContentLoaded', async () => {
  const paymentElement =
    getElementsByClassName<HTMLDivElement>('stripeProduct');

  if (paymentElement) {
    await Promise.all(
      paymentElement.map(async (element) => {
        const productId = element.innerText;
        element.innerHTML = '';
        element.append(skeleton('200px', '20px', '0 0 12px'));

        try {
          const productInfo = await getStripeCheckoutUrl(productId);

          element.innerHTML = '';
          element.append(
            <p>
              <a href={productInfo.url}>
                {!productInfo.price.unit_amount
                  ? 'Choose your price!'
                  : `${productInfo.price.currency.toUpperCase()} $${productInfo.price.unit_amount / 100}`}
              </a>
            </p>,
          );
        } catch (error) {
          console.error(error);
          element.innerHTML = '';
          element.append(
            <p>
              <i>Product is currently out of Stock or Unavailable!</i>
            </p>,
          );
        }
      }),
    );
  }
});
